/* eslint no-console: 0 */
const query = {};

const parse = () => {
  const querystring = window.location.search.substring(1);
  const values = querystring.split("&");
  values.forEach(value => {
    const tokens = value.split("=");
    if (tokens.length === 1) {
      return;
    }
    const key = tokens[0];
    value = tokens[1] || "";
    try {
      value = decodeURIComponent(value);
      if (/^\d+$/.test(value)) {
        value = Number(value);
      }
    } catch (e) {
      /*
       * Existen valores de la query string que pueden provocar URIError: URI malformed(…)
       * de ahí el try .. catch.
       * Ejemplo: /es/en/?param=tasda%FDasda
       */
      console.error(e.message);
    }
    query[key] = value;
  });
};

/**
 * There's three usage modes (see tests for examples)
 * @param {string} parameter parameter
 * @param {string} [regexp] regexp
 * @example
 * See tests
 * @returns {boolean} boolean
 */
const mode = (parameter, regexp) => {
  if (typeof regexp === "undefined") {
    return Boolean(query[parameter]);
  }
  const predicate = new RegExp(`\\b${regexp}\\b`, "i");
  return predicate.test(query[parameter]);
};

mode.query = query;
mode.parse = parse;

export default mode;
